<template>
    <div
        class="grey lighten-4 elevation-2 mb-4 v-card"
    >
        <v-subheader
            class="text-subtitle-1 font-weight-bold pa-4"
            :class="{ 'v-sheet': open }"
            @click="open = !open"
        >
            {{ room.type }}
            <v-spacer></v-spacer>
            <v-btn
                    icon
            >
                <v-icon v-if="!open">
                    mdi-chevron-up
                </v-icon>
                <v-icon v-else>
                    mdi-chevron-down
                </v-icon>
            </v-btn>
        </v-subheader>
        <v-expand-transition>
            <v-container
                    v-if="open"
            >
                <v-row>
                    <v-col
                            cols="12"
                            md="6"
                            v-for="(pax, j) in room.traveller"
                            :key="j"
                    >
                        <traveller
                                :index="j"
                                :item="pax"
                                :booking="booking"
                        >
                        </traveller>
                    </v-col>
                </v-row>
            </v-container>
        </v-expand-transition>
    </div>
</template>

<script>
    import Traveller from "../Traveller/Traveller";

    export default {
        components: {
            Traveller,
        },
        props: {
            room: {
                type: Object,
                required: true
            },
            booking: {
                type: Object,
                required: true,
            },
        },
        data: () => ({
            open: false,
        }),
    }
</script>

<style lang="scss" scoped>
    .v-subheader {
        cursor: pointer;
    }
</style>
